import { render, staticRenderFns } from "./ResourceBrowsing.vue?vue&type=template&id=39ae9c0f&scoped=true"
import script from "./ResourceBrowsing.vue?vue&type=script&lang=js"
export * from "./ResourceBrowsing.vue?vue&type=script&lang=js"
import style0 from "./ResourceBrowsing.vue?vue&type=style&index=0&id=39ae9c0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ae9c0f",
  null
  
)

export default component.exports